import { supabase } from "@/integrations/supabase/supabase";
import { useUserContext } from "@/contexts/UserContext";

const Logout = () => {
  const { setUser } = useUserContext();
  
  const handleLogout = async () => {
    try {
      // Try to sign out - this will fail gracefully if no session exists
      await supabase.auth.signOut();
    } catch (error) {
      // If signOut fails due to missing session, that's actually fine
      // The session is already gone, which is what we want
    }
    
    // Always clear the user from our app state
    setUser(null);
  };

  return handleLogout;
};

export default Logout;